import React, { useEffect } from "react";
import { allowScroll } from "../../services/popup";

const Modal = ({ children, onClose }) => {
  useEffect(() => {
    allowScroll(false);
    return () => {
      allowScroll(true);
    };
  }, []);

  return (
    <div className="modal w-full h-full fixed z-[9999] left-0 top-0 overflow-hidden animate-fade-in">
      <div
        onClick={onClose}
        className="relative h-full before:content-[''] before:absolute before:left-0 before:w-full before:h-full before:bg-a-75 before:z-10 z-20 flex items-center justify-center"
      >
        <div onClick={(e) => e.stopPropagation()}>{children}</div>
      </div>
    </div>
  );
};

export default React.memo(Modal);
